import { apiService } from '@/utils/api/index';

export default {
  /*
    GET REQUESTS
  */
  getPartners(page, size, query, filters, sort) {
    return apiService.tabGet(
      `/dashboard_vendor/partners/?page=${page}&page_size=${size}&search=${query}&sort=${sort}${filters}`
    );
  },

  getPartner(id) {
    return apiService.get(`/dashboard_vendor/partners/${id}/`);
  },

  getCategories() {
    return apiService.tabGet('/dashboard_vendor/directory/categories/');
  },
  getCollections() {
    return apiService.tabGet('/dashboard_vendor/directory/collections/');
  },
  getFilters() {
    return apiService.tabGet('/dashboard_vendor/directory/filters/');
  },

  getTiers() {
    return apiService.tabGet('/dashboard_vendor/directory/tiers/');
  },

  getBadges() {
    return apiService.tabGet('/dashboard_vendor/directory/badges/');
  },

  getDetails() {
    return apiService.tabGet('/dashboard_vendor/directory/details/');
  },

  getPartnerLocations(id) {
    return apiService.tabGet(`/dashboard_vendor/partners/${id}/locations/`);
  },

  getPartnerMainLocation(id) {
    return apiService.tabGet(`/dashboard_vendor/partners/${id}/main-location/`);
  },

  getTestimonials(id) {
    return apiService.tabGet(`/dashboard_vendor/partners/${id}/testimonials/`);
  },

  getPartnerFeaturedContent(id) {
    return apiService.tabGet(
      `/dashboard_vendor/partners/${id}/featured-content`
    );
  },

  getPartnerShowcases(id) {
    return apiService.tabGet(`/dashboard_vendor/partners/${id}/showcases`);
  },
  getInvitationDetail(id) {
    return apiService.get(`/dashboard_vendor/invite/${id}/`);
  },

  getContactRequests(page, size, query, filters, sort) {
    return apiService.tabGet(
      `/dashboard_vendor/contact_requests/?page=${page}&page_size=${size}&search=${query}&sort=${sort}${filters}`
    );
  },

  getContactDetail(id) {
    return apiService.get(`/dashboard_vendor/contact_requests/${id}/`);
  },

  getMatchmakingRequests(page, size, query, filters, sort, internal) {
    if (internal) {
      return apiService.tabGet(
        `/dashboard_vendor/internal/matchmaking_requests/?page=${page}&page_size=${size}&search=${query}&sort=${sort}${filters}`
      );
    } else {
      return apiService.tabGet(
        `/dashboard_vendor/matchmaking_requests/?page=${page}&page_size=${size}&search=${query}&sort=${sort}${filters}`
      );
    }
  },

  getMatchmakingDetail(id, internal) {
    if (internal) {
      return apiService.get(
        `/dashboard_vendor/internal/matchmaking_requests/${id}/`
      );
    } else {
      return apiService.get(`/dashboard_vendor/matchmaking_requests/${id}/`);
    }
  },

  getIntegrationPartners(page, size, query, filters, sort) {
    return apiService.tabGet(
      `/dashboard_vendor/integration_partners/?page=${page}&page_size=${size}&search=${query}&sort=${sort}${filters}`
    );
  },

  getIntegrationCandidates(endpoint) {
    return apiService.tabGet(endpoint);
  },

  getReviews(page, size, query, filters, sort) {
    return apiService.tabGet(
      `/dashboard_vendor/reviews/?page=${page}&page_size=${size}&search=${query}&sort=${sort}${filters}`
    );
  },

  getReviewDetail(id) {
    return apiService.get(`/dashboard_vendor/reviews/${id}/`);
  },

  getSettings() {
    return apiService.tabGet('dashboard_vendor/directory/settings/');
  },

  getBranding() {
    return apiService.tabGet('dashboard_vendor/directory/branding/');
  },

  getIntegrationProfile(id) {
    return apiService.tabGet(`/dashboard_vendor/integration_partners/${id}/`);
  },

  getIntegrationInvitationDetail(id) {
    return apiService.get(
      `/dashboard_vendor/integration_partners/invite/${id}/`
    );
  },

  getIntegrationShowcases(id) {
    return apiService.tabGet(
      `/dashboard_vendor/integration_partners/${id}/showcase/`
    );
  },

  saveIntegrationShowcase(id, data) {
    return apiService.post(
      `/dashboard_vendor/integration_partners/${id}/showcase/`,
      data
    );
  },

  getIntegrationUseCases(id) {
    return apiService.tabGet(
      `/dashboard_vendor/integration_partners/${id}/use_cases/`
    );
  },

  getIntegrationMedia(id) {
    return apiService.tabGet(
      `/dashboard_vendor/integration_partners/${id}/featured-content/`
    );
  },

  getIntegrationQuotes(id) {
    return apiService.tabGet(
      `/dashboard_vendor/integration_partners/${id}/quote/`
    );
  },

  getIntegrationResources(id) {
    return apiService.tabGet(
      `/dashboard_vendor/integration_partners/${id}/resources/`
    );
  },

  getIntegrationSupport(id) {
    return apiService.tabGet(
      `/dashboard_vendor/integration_partners/${id}/support`
    );
  },

  getIntegrationCTA(id) {
    return apiService.tabGet(
      `/dashboard_vendor/integration_partners/${id}/button/`
    );
  },

  getPublicProfiles(page, size, query) {
    return apiService.tabGet(
      `/dashboard_vendor/public_profiles/?page=${page}&page_size=${size}&search=${query}`
    );
  },

  getPublicProfileProfile(id) {
    return apiService.tabGet(`/dashboard_vendor/public_profiles/${id}/`);
  },

  getPublicProfileUseCases(id) {
    return apiService.tabGet(
      `/dashboard_vendor/public_profiles/${id}/use_cases/`
    );
  },

  getPublicProfileQuotes(id) {
    return apiService.tabGet(`/dashboard_vendor/public_profiles/${id}/quote/`);
  },

  getPublicProfileResources(id) {
    return apiService.tabGet(
      `/dashboard_vendor/public_profiles/${id}/resources/`
    );
  },

  getPublicProfileSupport(id) {
    return apiService.tabGet(
      `/dashboard_vendor/public_profiles/${id}/support/`
    );
  },

  getAgencyIntegrationPartnerSupport(id) {
    return apiService.tabGet(
      `/dashboard_vendor/agency_integration_partners/${id}/support`
    );
  },

  getPublicProfileCTA(id) {
    return apiService.tabGet(`/dashboard_vendor/public_profiles/${id}/button/`);
  },

  getClients(id) {
    return apiService.tabGet(`/dashboard_vendor/partners/${id}/clients/`);
  },

  getFeaturedContent(id) {
    return apiService.tabGet(
      `/dashboard_vendor/partners/${id}/featured-content/`
    );
  },

  getResources(id) {
    return apiService.tabGet(`/dashboard_vendor/partners/${id}/resources/`);
  },

  /*
    POST REQUESTS
  */
  sendInvite(data) {
    return apiService.post('/dashboard_vendor/invite/', data);
  },

  resendInvite(data) {
    return apiService.post('/dashboard_vendor/resend/invite/', data);
  },

  savePartnerShowcase(id, data) {
    return apiService.post(`/dashboard_vendor/partners/${id}/showcases`, data);
  },

  savePartnerLocations(id, data) {
    return apiService.post(`/dashboard_vendor/partners/${id}/locations/`, data);
  },

  saveTestimonials(id, data) {
    return apiService.post(
      `/dashboard_vendor/partners/${id}/testimonials/`,
      data
    );
  },

  saveFeaturedContent(id, data) {
    return apiService.post(
      `/dashboard_vendor/partners/${id}/featured-content/`,
      data
    );
  },

  saveClients(id, data) {
    return apiService.post(`/dashboard_vendor/partners/${id}/clients/`, data);
  },

  saveBadges(data) {
    return apiService.post('/dashboard_vendor/directory/badges/', data);
  },

  saveTiers(data) {
    return apiService.post('/dashboard_vendor/directory/tiers/', data);
  },

  saveFilters(data) {
    return apiService.post('/dashboard_vendor/directory/filters/', data);
  },

  saveCategories(data) {
    return apiService.post('/dashboard_vendor/directory/categories/', data);
  },

  saveCollections(data) {
    return apiService.post('/dashboard_vendor/directory/collections/', data);
  },

  sendIntegrationInvite(data) {
    return apiService.post(
      '/dashboard_vendor/integration_partners/invite/',
      data
    );
  },

  resendIntegrationInvite(data) {
    return apiService.post(
      '/dashboard_vendor/integration_partners/resend/invite/',
      data
    );
  },

  createIntegrationPartnership(data) {
    return apiService.post('/dashboard_vendor/integration_partners/', data);
  },

  createManualIntegrationPartnership(data) {
    return apiService.post(
      '/dashboard_vendor/integration_partners/manual_create/',
      data
    );
  },

  saveIntegrationUseCases(id, data) {
    return apiService.post(
      `/dashboard_vendor/integration_partners/${id}/use_cases/`,
      data
    );
  },

  saveIntegrationQuote(id, data) {
    return apiService.post(
      `/dashboard_vendor/integration_partners/${id}/quote/`,
      data
    );
  },

  saveIntegrationResources(id, data) {
    return apiService.post(
      `/dashboard_vendor/integration_partners/${id}/resources/`,
      data
    );
  },

  saveIntegrationSupport(id, data) {
    return apiService.post(
      `/dashboard_vendor/integration_partners/${id}/support`,
      data
    );
  },

  saveAgencyIntegrationPartners(id, data) {
    return apiService.post(
      `/dashboard_vendor/agency_integration_partners/${id}/support`,
      data
    );
  },

  saveIntegrationCTA(id, data) {
    return apiService.post(
      `/dashboard_vendor/integration_partners/${id}/button/`,
      data
    );
  },

  saveIntegrationMedia(id, data) {
    return apiService.post(
      `/dashboard_vendor/integration_partners/${id}/featured-content/`,
      data
    );
  },

  savePublicProfileMedia(id, data) {
    return apiService.post(
      `/dashboard_vendor/integration_partners/${id}/featured-content/`,
      data
    );
  },

  savePublicProfileUseCases(id, data) {
    return apiService.post(
      `/dashboard_vendor/public_profiles/${id}/use_cases/`,
      data
    );
  },

  savePublicProfileQuote(id, data) {
    return apiService.post(
      `/dashboard_vendor/public_profiles/${id}/quote/`,
      data
    );
  },

  savePublicProfileResources(id, data) {
    return apiService.post(
      `/dashboard_vendor/public_profiles/${id}/resources/`,
      data
    );
  },

  savePublicProfileSupport(id, data) {
    return apiService.post(
      `/dashboard_vendor/public_profiles/${id}/support/`,
      data
    );
  },

  savePublicProfileCTA(id, data) {
    return apiService.post(
      `/dashboard_vendor/public_profiles/${id}/button/`,
      data
    );
  },

  /*
    PUT REQUESTS
  */
  savePartner(id, data) {
    return apiService.put(`/dashboard_vendor/partners/${id}/`, data);
  },

  saveBranding(data) {
    return apiService.put('/dashboard_vendor/directory/branding/', data);
  },

  saveResources(id, data) {
    return apiService.post(`/dashboard_vendor/partners/${id}/resources/`, data);
  },

  saveSettings(data) {
    return apiService.put('/dashboard_vendor/directory/settings/', data);
  },

  saveIntegrationProfile(id, data) {
    return apiService.put(
      `/dashboard_vendor/integration_partners/${id}/`,
      data
    );
  },

  updateIntegrationSupport(id, data) {
    return apiService.put(
      `/dashboard_vendor/integration_partners/${id}/support/update`,
      data
    );
  },

  updateAgencyIntegrationPartnersSupport(id, data) {
    return apiService.put(
      `/dashboard_vendor/agency_integration_partners/${id}/support/update`,
      data
    );
  },

  updateIntegrationCTA(id, data) {
    return apiService.put(
      `/dashboard_vendor/integration_partners/${id}/button/update/`,
      data
    );
  },

  savePublicProfileProfile(id, data) {
    return apiService.put(`/dashboard_vendor/public_profiles/${id}/`, data);
  },

  updatePublicProfileSupport(id, data) {
    return apiService.put(
      `/dashboard_vendor/public_profiles/${id}/support/update/`,
      data
    );
  },

  updatePublicProfileCTA(id, data) {
    return apiService.put(
      `/dashboard_vendor/public_profiles/${id}/button/update`,
      data
    );
  },

  /*
    PATCH REQUESTS
  */
  updateDirectoryDetails(data) {
    return apiService.patch('/dashboard_vendor/directory/details/', data);
  },

  updateReviewStatus(id, data) {
    return apiService.patch(`/dashboard_vendor/reviews/${id}/`, data);
  },

  updateMainLocation(id, data) {
    return apiService.patch(
      `/dashboard_vendor/partners/${id}/main-location/`,
      data
    );
  },

  /*
    DELETE REQUESTS
  */
  deletePartner(id) {
    return apiService.delete(`/dashboard_vendor/partners/${id}/`);
  },

  deleteIntegrationPartner(id) {
    return apiService.delete(`/dashboard_vendor/integration_partners/${id}/`);
  },

  deleteInvitation(id) {
    return apiService.delete(`/dashboard_vendor/invite/${id}/`);
  },

  deleteIntegrationInvitation(id) {
    return apiService.delete(
      `/dashboard_vendor/integration_partners/invite/${id}/`
    );
  },
};
